import {
    styleDivider,
    styleRowInput,
    styleSelectedOrHoveredButton,
    styleRelatoriosConfigDescricao,
    styleRelatoriosConfigTitulo,
    styleRelatorioConfigHeader,
    styleRelatoriosConfig,
    styleRelatorioWidth,
    styleRelatoriosConfigWeight,
    styleRelatorios,
    styleOpcoesRelatorios,
    styleOpcoesRelatoriosHover,
    styleNormalStateButton,
    styleLabelInput,
    styleLargeRow,
    styleRowDate,
    styleDivDate,
    styleLabelDate,
    styleActionButtons,
    styleStandartButton,
    styleLinearLoading,
    styleHeaderAutoReply,
    styleDivSchedule,
    stylePeriod,
    styleButtonConfirm,
    styleSelectReport,
    styleLabelSelectReport,
    styleLoading
} from "./sxRelatoriosConfig"
import { useState, useEffect, useContext, useMemo, useRef } from "react"
import OneDatePicker from "../../../Components/OneDatePicker/OneDatePicker"
import moment from "moment"
import OneButton from "../../../Components/OneButton/OneButton"
import OneSplitButton from "../../../Components/OneSplitButton/OneSplitButton"
import OneInput from "../../../Components/OneInput/OneInput"
import OneCheckbox from "../../../Components/OneCheckbox/OneCheckbox"
import OneAutocomplete from "../../../Components/OneAutocomplete/OneAutocomplete"
import { Grid, Box, CircularProgress, LinearProgress } from "@mui/material"
import { FilterAltOff, ForwardToInbox, Send } from "@mui/icons-material"
import { UserContext } from "../../../Providers/UserContext/UserContex"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { LogadoContext } from "../../../Providers/LogadoContext/LogadoContext"
import { showNotify } from '../../../../src/Utils/Utils'

const RelatoriosConfig = () => {
    const [relatorios, setRelatorios] = useState([])
    const [periodo] = useState([
        { id: 1, periodo: "Diário" },
        { id: 2, periodo: "Semanal" },
        { id: 3, periodo: "Quinzenal" },
        { id: 4, periodo: "Mensal" }
    ])
    const [diaSemana] = useState([
        { id: 1, dia_semana: "S" },
        { id: 2, dia_semana: "T" },
        { id: 3, dia_semana: "Q" },
        { id: 4, dia_semana: "Q" },
        { id: 5, dia_semana: "S" },
        { id: 6, dia_semana: "S" },
        { id: 7, dia_semana: "D" }
    ])
    const [opcaoTeste] = useState([])
    const [optionsSplitButton] = useState([
        { name: 'Exportar em PDF (.pdf)', value: 'pdf' },
        { name: 'Exportar em CSV (.csv)', value: 'csv' },
        { name: 'Exportar em XLSX (.xlsx)', value: 'xlsx' }
    ])
    const [mappingComponents, setMappingComponents] = useState(null)
    const [hoveredIndex, setHoveredIndex] = useState(null)
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [formData, setFormData] = useState({})
    const [selectedReport, setSelectedReport] = useState("")
    const [selectedPeriodoIndex, setSelectedPeriodoIndex] = useState("")
    const [selectedPeriodoHoveredIndex, setSelectedPeriodoHoveredIndex] = useState("")
    const [selectedDiaSemanaIndex, setSelectedDiaSemanaIndex] = useState("")
    const [selectedDiaSemanaHoveredIndex, setSelectedDiaSemanaHoveredIndex] = useState("")
    const [toogleEmail, setToogleEmail] = useState(false)
    const [colorHold, setColorHold] = useState("#a8a4ab")
    const [clearAllFilters, setClearAllFilters] = useState(false)
    const [loadingFilters, setLoadingFilters] = useState(false)
    const [loadingExport, setLoadingExport] = useState(false)
    const [condominios, setCondominios] = useState([])
    const [incluirPessoasExcluidas, setIncluirPessoasExcluidas] = useState(false)

    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { user } = useContext(UserContext)
    const { logado } = useContext(LogadoContext)

    const permissoesRef = useRef(user?.permissoes)
    permissoesRef.current = user?.permissoes

    const sessionId = localStorage.getItem('o_mo_id_session')
    const semData = [3, 4, 6, 7, 8, 11, 20, 24, 32]
    const incluirExclidos = [1]

    const handleChange = (event) => {
        if (event.target.value !== undefined) {
            setFormData({ ...formData, [event.target.name]: event.target.value })
        }
    }

    const handleCheckboxChange = (event) => {
        setIncluirPessoasExcluidas(event.target.checked)
    }

    const handleControlDisabled = () => {
        if (!formData.id_central) {
            return true
        }

        let verifyRequired = Array.isArray(mappingComponents)
            ? mappingComponents.filter(item => {
            // Remover o formato_arquivo e periodo do filtro
                if (item.componente === 'formato_arquivo' || item.componente === 'periodo') {
                    return false
                }
                return item.obrigatorio && !formData[item.componente]
            })
            : []
        if (verifyRequired.length > 0) {
            return true
        }
        return false
    }

    const getWsFiltros = (msg) => {
        setMappingComponents(msg.data)
    }

    const handleLoadFilters = (report, index) => {
        setLoadingFilters(true)
        setSelectedPeriodoIndex(null)
        setSelectedDiaSemanaIndex(null)
        setSelectedIndex(index)
        setSelectedReport(report)
        setClearAllFilters(true)
        if (formData.id_central) {
            // se tiver id_central, manter ele no formData e limpar o restante
            setFormData({ ...formData, id_central: formData.id_central })
        } else {
            setFormData({})
        }
        if (report.id && report.id > 0) {
            addRoute("getPreenchimentoFiltros", getWsFiltros)
            sendWs("getPreenchimentoFiltros", {
                codigo: report.id,
                id_central: formData.id_central
            })
        }
        setLoadingFilters(false)
    }

    const handleOptionSelect = (extensionFormat) => {
        handleSendData(extensionFormat)
    }

    const handleSendData = async (extensionFormat) => {
        setLoadingExport(true)
        showNotify('success', 'Seu relatório está sendo gerado e será baixado. Aguarde...', { autoClose: 4000 })

        let dataToSend = {}

        if (!extensionFormat) { extensionFormat = 'pdf' }

        mappingComponents.forEach((item) => {
            if (item.componente) {
                dataToSend[item.componente] = null
            }
            if (item.componente == 'formato_arquivo' && !extensionFormat) {
                dataToSend[item.componente] = item.valor_inicial
            } else if (item.componente == 'formato_arquivo' && extensionFormat) {
                dataToSend[item.componente] = extensionFormat
            }
        })
        dataToSend = { ...dataToSend, ...formData }

        // Filtrar valores não vazios do formData
        const nonEmptyFormData = Object.fromEntries(
            Object.entries(formData).filter(([_, value]) => value)
        )

        dataToSend = { ...dataToSend, ...nonEmptyFormData }

        const filteredData = Object.fromEntries(
            Object.entries(dataToSend).filter(([_, value]) => value !== null)
        )

        setTimeout(() => {
            setLoadingExport(false)
        }, 1000)

        const getWsDownload = (msg) => {
            if (msg.data?.msg?.tempo && msg.data?.msg?.tempo.length > 0) {
                showNotify('warning', msg.data.msg.tempo)
                return
            }

            let urlFormatada

            if (msg.data.cod == 11) {
                if (extensionFormat == 'pdf') {
                    urlFormatada = msg.data.file.replace(/(_geral|_mensal|_anual)/gi, '').replace(/^.*[\\/]([^\\/]+)_\d+(\.pdf)$/, '$1$2')
                } else if (extensionFormat == 'csv' || extensionFormat == 'xlsx') {
                    urlFormatada = msg.data.file.replace(/(_geral|_mensal|_anual)/gi, '').replace(/^.*[\\/]/, "")
                }
            } else {
                if (extensionFormat == 'pdf') {
                    urlFormatada = msg.data.file.replace(/^.*[\\/]([^\\/]+)_\d+(\.pdf)$/, "$1$2")
                } else if (extensionFormat == 'csv' || extensionFormat == 'xlsx') {
                    urlFormatada = msg.data.file.replace(/^.*[\\/]/, "")
                }
            }
            let urlSemExtensao = urlFormatada.split('.')[0]
            let fileName = msg.data.file.replace(/^.*[\\/]/, "")

            // Se a pasta tiver nome diferente do padrao, ajusto o nome
            const nome_pastas = {
                manter_aberto: 'manterAberto',
                acesso_sem_saida: 'acessoSemSaida',
                quem_esta_dentro: 'quemEstaDentro',
                interTravamento: 'interTravamentos',
                monitoramento_simples: 'monitoramentoSimples',
                monitoramento_detalhado: 'monitoramentoDetalhado',
                ordem_servico_template: 'ordemServicoTemplate',
                ult_disp_cad: 'ult_disp_cadastrados'
            }

            for (let chave in nome_pastas) {
                if (urlSemExtensao === chave) {
                    urlSemExtensao = nome_pastas[chave]
                    break
                }
            }

            let url = `${window.location.origin.replace(':3003', '')}/wsOnePortaria/QrToken/relatorios/${urlSemExtensao}/${fileName}`
            window.open(url, "_blank")
        }
        addRoute("relatorio", getWsDownload)
        sendWs("relatorio", { ...filteredData, codigoRel: selectedReport.id, tipoRel: extensionFormat, id_session: sessionId })
    }

    const handleValueChange = (componente) => (event) => {
        setFormData({ ...formData, [componente]: event.target.value })
    }

    const handleChangeCondom = (e) => {
        setFormData({ ...formData, id_central: e.target.value })
    }

    const handleClickClear = () => {
        setSelectedIndex(null)
        setSelectedReport("")
        setMappingComponents(null)
        setClearAllFilters(true)
        setFormData({})
        setSelectedPeriodoIndex(null)
        setSelectedDiaSemanaIndex(null)
    }

    useEffect(() => {
        if (clearAllFilters) {
            setClearAllFilters(false) // Reseta após a execução
            let options = {}

            if (formData.id_central) {
                let id_central = formData.id_central
                options.id_central = id_central
            }

            if (formData.dt_inicial) {
                let dt_inicial = formData.dt_inicial
                options.dt_inicial = dt_inicial
            }

            if (formData.dt_final) {
                let dt_final = formData.dt_final
                options.dt_final = dt_final
            }

            setFormData(options)
        }
    }, [clearAllFilters])

    useEffect(() => {
        if (condominios.length === 0 && logado && user.id) {
            getCondominios()
        }
    }, [condominios, user, logado, mappingComponents])

    const getCondominios = () => {
        addRoute('getCondominios', handleGetCondominios)
        sendWs('getCondominios', { userId: user.id })
    }

    const handleGetCondominios = (msg) => {
        if (msg.data && msg.data.status) {
            setCondominios(msg.data.condominios)
        }
    }

    const getIsThreshold = (componente) =>
        componente === "idPessoas" || componente === "idTags" || componente === "cdAcessoVisitante" || componente === "cdAcessoMorador"

    const handleThresholdFetch = async (searchText, id_central, componente) => {
        let dados

        if (selectedReport.id && selectedReport.id > 0) {
            sendWs("preencherCampos", {
                text: searchText,
                id_central,
                campo: componente,
                incluir_pessoas_excluidas: incluirPessoasExcluidas
            })
            dados = await getPreencherCampos()

            let index = mappingComponents.findIndex((item) => item.componente == componente)

            setMappingComponents(mappingComponents.map((item, i) => {
                if (i === index) {
                    return { ...item, valores: dados }
                }
                return item
            }))
        }
        return dados
    }

    const getPreencherCampos = async () => {
        const p = new Promise((resolve) => {
            addRoute("preencherCampos", (msg) => {
                resolve(msg.data.valores)
            })
        })
        return p
    }

    const getWsResponse = (msg) => {
        let reports = msg.data
        const permissoes = permissoesRef.current
        if (permissoes) {
            const relatoriosPerm = permissoes['2']?.itens
            if (relatoriosPerm) {
                reports = reports.filter((_, index) => {
                    const permissao = relatoriosPerm[String(index + 1)]
                    return permissao && permissao[1] == 1
                })
            }
        }
        setRelatorios(reports)
    }

    useEffect(() => {
        addRoute("listaRelatorios", getWsResponse)
        sendWs("listaRelatorios")
    }, [])

    useEffect(() => {
        if (selectedReport.id && selectedReport.id > 0) {
            addRoute("getPreenchimentoFiltros", getWsFiltros)
            sendWs("getPreenchimentoFiltros", {
                codigo: selectedReport.id,
                id_central: formData.id_central
            })
        }
    }, [formData.id_central, incluirPessoasExcluidas])

    const handleOptions = (mappingComponent) => {
        if (mappingComponent.valores !== undefined) {
            return mappingComponent.valores.map((valor) => {
                return {
                    id: valor.id,
                    descricao: valor.descricao
                }
            })
        } else {
            return [{ id: '', descricao: '' }]
        }
    }

    const mappedComponents = useMemo(() => {
        if (!mappingComponents || !Array.isArray(mappingComponents)) return null

        return mappingComponents.map((mappingComponent) => {
            if (
                mappingComponent.componente !== "formato_arquivo" &&
                    mappingComponent.componente !== "periodo"
            ) {
                const isThreshold = getIsThreshold(mappingComponent.componente)
                return (
                    <Box style={styleRowInput} key={mappingComponent.componente}>
                        <span style={styleLabelInput}>
                            {mappingComponent.nome}:
                        </span>
                        {
                            mappingComponent.tipoInput == 'text'
                            ? <Box style={{ width: "100%" }}>
                                <OneInput name={mappingComponent.indice} onChange={handleChange} disabled={!formData.id_central} newSx={{ width: "100%", height: '32px', backgroundColor: !formData.id_central ? '#f0f0f0' : '', color: !formData.id_central ? '#a9a9a9' : '' }} maxLength={mappingComponent.maxLength || 255}></OneInput>
                            </Box>
                            : <Box style={{ width: "100%" }}>
                                <OneAutocomplete
                                    disabled={!formData.id_central}
                                    style={{
                                        backgroundColor: !formData.id_central ? '#f0f0f0' : '',
                                        color: !formData.id_central ? '#a9a9a9' : ''
                                    }}
                                    id={mappingComponent.componente}
                                    options= {handleOptions(mappingComponent)}
                                    todos={mappingComponent.opcao_todos}
                                    reset={clearAllFilters}
                                    onChange={handleValueChange(mappingComponent.componente)}
                                    required={
                                        mappingComponent.obrigatorio &&
                                                (!formData[mappingComponent.componente] || formData[mappingComponent.componente]?.length === 0)
                                    }
                                    multiple={mappingComponent.multiplo === 1}
                                    isThreshold={isThreshold}
                                    onThresholdFetch={isThreshold ? (searchText) => handleThresholdFetch(searchText, formData.id_central, mappingComponent.componente) : undefined}
                                    defaultValue={mappingComponent.valores?.find((val) => val.descricao == 'Todos')?.id}
                                />
                            </Box>
                        }
                    </Box>
                )
            }
            return null
        })
    }, [mappingComponents, clearAllFilters, formData, opcaoTeste])

    return (
        <Box style={styleRelatoriosConfig}>
            {/* Lista de relatório */}
            <Box style={styleRelatorioWidth}>
                <Box style={styleRelatorioConfigHeader}>
                    <span style={styleRelatoriosConfigWeight}>Selecione o relatório</span>
                </Box>
                <Box style={styleRelatorios}>
                    {relatorios && relatorios.length > 0 && relatorios.map((relatorio, index) => {
                        return (
                            <Box
                                key={relatorio.id}
                                style={
                                    selectedIndex === index || hoveredIndex === index
                                        ? styleOpcoesRelatoriosHover
                                        : styleOpcoesRelatorios
                                }
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                onClick={() => {
                                    // Alterna a seleção e atualiza o título selecionado
                                    if (selectedIndex === index) {
                                        handleClickClear()
                                    } else {
                                        handleLoadFilters(relatorio, index)
                                    }
                                }}
                            >
                                <span style={styleRelatoriosConfigTitulo}>{relatorio.id} - {relatorio.titulo}</span>
                                <span style={styleRelatoriosConfigDescricao}>{relatorio.descricao}</span>
                            </Box>)
                    })}
                </Box>
            </Box>
            {/* Filtros necessários para gerar o relatório */}
            <Box style={styleRelatorioWidth}>
                <Box style={styleRelatorioConfigHeader}>
                    <span style={styleRelatoriosConfigWeight}>Filtros necessários</span>
                </Box>
                <Box style={{ ...styleRelatorios }} >
                    {
                        mappingComponents &&
                        <>
                            <Box style={{ borderRadius: '5px', padding: '5px', display: 'flex', flexDirection: 'column' }}>
                                {selectedReport && (
                                    <Box style={styleRelatoriosConfigTitulo}>
                                        {selectedReport.id} - {selectedReport.titulo}
                                    </Box>
                                )}
                            </Box>
                            <Box style={styleDivider}></Box>
                            <Box style={styleRowInput}>
                                <span style={styleLabelInput}>Condomínio:</span>
                                <Box style={{ width: '100%' }}>
                                    <OneAutocomplete
                                        options={condominios}
                                        label="nome"
                                        valor="id_central"
                                        onChange={handleChangeCondom}
                                        required={!formData.id_central}
                                    ></OneAutocomplete>
                                </Box>
                            </Box>
                            <Box style={styleDivider}></Box>
                            {
                                !loadingFilters &&
                                <>
                                    { !semData.includes(selectedReport.id) && (
                                        <><Box style={styleLargeRow}>
                                            <Grid container sx={styleRowDate}>
                                                <Box style={styleDivDate}>
                                                    <span style={styleLabelDate}>Data Inicial:</span>
                                                    <OneDatePicker
                                                        name="dt_inicial"
                                                        defaultValue={formData?.dt_inicial || moment().startOf('day').format('yyyy-MM-DDTHH:mm')}
                                                        callback={handleChange} />
                                                </Box>
                                                <Box style={styleDivDate}>
                                                    <span style={styleLabelDate}>Data
                                                         Final:</span>
                                                    <OneDatePicker
                                                        name="dt_final"
                                                        defaultValue={formData?.dt_final || moment().startOf('day').format('yyyy-MM-DDTHH:mm')}
                                                        callback={handleChange} />
                                                </Box>
                                            </Grid>
                                        </Box><Box style={styleDivider}></Box></>
                                    )
                                    }
                                    {!formData.id_central &&
                                    <Box style={styleRowInput}>
                                        <span style={styleLabelInput}></span>
                                        <Box sx={{ color: 'red', width: '100%', fontSize: '12px' }}>Selecione o condomínio</Box>
                                    </Box>
                                    }
                                    {incluirExclidos.includes(selectedReport.id) &&
                                    <Box style={styleRowInput}>
                                        <span style={styleLabelInput}>Opção:</span>
                                        <Box style={{ width: '100%' }}>
                                            <OneCheckbox
                                                text="Incluir pessoas excluídas"
                                                defaultChecked={false}
                                                colorBox="black"
                                                colorLabel="black"
                                                labelSize="12px"
                                                onChange={handleCheckboxChange}
                                            />
                                        </Box>
                                    </Box>
                                    }
                                    <Box>{mappedComponents}</Box>{/* Box que renderiza os filtros */}
                                    <Box style={styleRowInput}>
                                        {/* INICIO - É necessário aguardar a implementação do envio automático */}
                                        <Box style={{ marginTop: '5px' }}>
                                            {
                                                false &&
                                            <OneButton
                                                variant="contained"
                                                color="one_primary"
                                                newSx={{
                                                    border: '0px',
                                                    backgroundColor: colorHold,
                                                    '&:hover': {
                                                        backgroundColor: '#535353'
                                                    }
                                                }}
                                                IconStart={ForwardToInbox}
                                                sxIconStart={{ fontSize: '16px' }}
                                                onClick={() => setToogleEmail((current) => {
                                                    setColorHold(current ? '#a8a4ab' : '#535353')
                                                    return !current
                                                })}
                                            >
                                                AGENDAR ENVIO AUTOMÁTICO
                                            </OneButton>
                                            }
                                        </Box>
                                        <Box style={styleActionButtons}>
                                            <OneButton
                                                variant="contained"
                                                color="one_primary"
                                                newSx={styleStandartButton}
                                                sxIconStart={{ fontSize: '16px' }}
                                                IconStart={FilterAltOff}
                                                onClick={() => setClearAllFilters(true)}
                                            >
                                                <span style={{ paddingRight: '5px' }}>
                                                    LIMPAR FILTROS
                                                </span>
                                            </OneButton>
                                            {/* FIM - Botão em stand by, até que o componente de envio automático esteja pronto */}
                                            {
                                                false &&
                                                <OneButton
                                                    variant="contained"
                                                    color="one_primary"
                                                    newSx={styleStandartButton}
                                                    IconStart={Send}
                                                    sxIconStart={{ fontSize: '16px' }}
                                                >
                                                    ENVIAR EMAIL
                                                </OneButton>
                                            }
                                            <OneSplitButton
                                                options={optionsSplitButton}
                                                label="EXPORTAR RELATÓRIO"
                                                onClick={() => { handleSendData() }}
                                                onOptionSelect={handleOptionSelect}
                                                allDisabled={handleControlDisabled() || loadingExport}
                                            />
                                        </Box>
                                    </Box>
                                </>
                            }
                            {
                                !loadingExport && !loadingFilters &&
                                <Box style={styleDivider}></Box>
                            }
                            {
                                loadingExport &&
                                <LinearProgress color="secondary" style={styleLinearLoading} />
                            }
                            {/* Componente de envio automático TODO */}
                            {
                                toogleEmail &&
                                <>
                                    <Box style={styleLargeRow}>
                                        <span style={styleHeaderAutoReply}>
                                            Criar gatilho para envio automático deste relatório.
                                        </span>
                                    </Box>
                                    <Box style={styleRowInput}>
                                        <span style={styleLabelInput}>
                                            Email para envio:
                                        </span>
                                        <Box style={{ width: '86%' }}>
                                            <OneInput />
                                        </Box>
                                    </Box>
                                    <Box style={stylePeriod}>
                                        <span style={styleLabelInput}>
                                            Selecione o período:
                                        </span>
                                        <Box style={styleDivSchedule}>
                                            <Grid container gap={2}>
                                                {periodo.map((item, index) => (
                                                    <OneButton
                                                        key={item.id}
                                                        newSx={
                                                            selectedPeriodoIndex === index || selectedPeriodoHoveredIndex === index
                                                                ? styleSelectedOrHoveredButton
                                                                : styleNormalStateButton
                                                        }
                                                        onMouseEnter={() => setSelectedPeriodoHoveredIndex(index)}
                                                        onMouseLeave={() => setSelectedPeriodoHoveredIndex(null)}
                                                        onClick={() => {
                                                            if (selectedPeriodoIndex === index) {
                                                                setSelectedPeriodoIndex(null)
                                                            } else {
                                                                setSelectedPeriodoIndex(index)
                                                            }
                                                        }}
                                                    >
                                                        {item.periodo}
                                                    </OneButton>
                                                ))}
                                            </Grid>
                                        </Box>
                                    </Box>
                                    <Box style={styleLargeRow}>
                                        <span style={styleLabelInput}>
                                            Selecione o dia da semana:
                                        </span>
                                        <Box style={styleDivSchedule}>
                                            <Grid container gap={2}>
                                                {diaSemana.map((item, index) => (
                                                    <OneButton
                                                        key={item.id}
                                                        newSx={
                                                            selectedDiaSemanaIndex === index || selectedDiaSemanaHoveredIndex === index
                                                                ? styleSelectedOrHoveredButton
                                                                : styleNormalStateButton
                                                        }
                                                        onMouseEnter={() => setSelectedDiaSemanaHoveredIndex(index)}
                                                        onMouseLeave={() => setSelectedDiaSemanaHoveredIndex(null)}
                                                        onClick={() => {
                                                            if (selectedDiaSemanaIndex === index) {
                                                                setSelectedDiaSemanaIndex(null)
                                                            } else {
                                                                setSelectedDiaSemanaIndex(index)
                                                            }
                                                        }}
                                                    >
                                                        {item.dia_semana}
                                                    </OneButton>
                                                ))}
                                            </Grid>
                                        </Box>
                                    </Box>
                                    <Box style={styleActionButtons}>
                                        <OneButton
                                            variant="contained"
                                            color="one_primary"
                                            newSx={styleStandartButton}
                                            IconStart={Send}
                                            sxIconStart={{ fontSize: '16px' }}
                                        >
                                            TESTAR ENVIO
                                        </OneButton>
                                        <OneButton
                                            variant="contained"
                                            color="one_primary"
                                            newSx={styleButtonConfirm}
                                        >
                                            CRIAR RELATÓRIO AUTOMÁTICO
                                        </OneButton>
                                    </Box>
                                </>
                            }
                        </>
                    }
                    {
                        !mappingComponents && !loadingFilters &&
                        <Box style={styleSelectReport}>
                            <span style={styleLabelSelectReport}>
                                Selecione um relatório.
                            </span>
                        </Box>
                    }
                    {
                        loadingFilters &&
                        <Box style={styleLoading}>
                            <CircularProgress color="secondary" />
                            <span style={{ color: '#000' }}>Carregando...</span>
                        </Box>
                    }
                </Box>
            </Box>
        </Box>
    )
}

export default RelatoriosConfig
